import { isStringNumber } from './isStringNumber'

/**
 * Is value just string of decimal numbers
 * @param {string} stringNumber
 * @param {string} decimalPoint
 */
export const isStringDecimalNumber = (stringNumber, decimalPoint = '.') => {
  let [intValue, floatValue] = stringNumber.split(decimalPoint)
  if (intValue.startsWith('-')) intValue = intValue.substring(1)
  return isStringNumber(intValue) && (!floatValue || isStringNumber(floatValue))
}
